import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    if (!/^#[\w-]+$/.test(window.location.hash)) return;

    const tab = this.element.querySelector(`a[href="${window.location.hash}"]`);
    if (tab) $(tab).tab("show");
  }
}
